import type { ProductDetailPageDataDef } from "@swo/storefront";
import type React from "react";
import { PDPBreadcrumbs } from "../PDPBreadcrumbs";
import { PDPNameHeadline } from "./PDPNameHeadline";

export const ProductDetailsIntro: React.FC<{
  breadcrumbs: ProductDetailPageDataDef["taxonomy"]["breadcrumbs"];
  SubheadlineElement: React.ReactNode;
  isNew: boolean;
  name: string;
}> = ({ breadcrumbs, SubheadlineElement, isNew, name }) => {
  return (
    <>
      <PDPBreadcrumbs data={breadcrumbs} />

      <PDPNameHeadline headline={name} subheadline={undefined} isNew={isNew}>
        {SubheadlineElement}
      </PDPNameHeadline>
    </>
  );
};
